var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnkr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#006DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69133 2.89919L12.1771 4.66707C12.6847 4.9246 13 5.43483 13 5.99864V6.80472H11.7147V5.99864C11.7147 5.91353 11.6669 5.83633 11.5901 5.79734L8.10456 4.02957C8.03922 3.99651 7.96111 3.9964 7.89556 4.02968L4.40978 5.79734C4.33311 5.83633 4.28544 5.91353 4.28544 5.99864V6.80472H3V5.99864C3 5.43483 3.31533 4.9246 3.82278 4.66707L7.30878 2.89919C7.74156 2.67944 8.25822 2.67944 8.69133 2.89919ZM9.09974 7.94581C9.09974 7.34608 8.60618 6.85837 7.99951 6.85837C7.39285 6.85837 6.89929 7.34608 6.89929 7.94581C6.89929 8.54531 7.39285 9.03325 7.99951 9.03325C8.60618 9.03325 9.09974 8.54531 9.09974 7.94581ZM11.5903 10.2031C11.6669 10.1643 11.7147 10.0872 11.7147 10.0019V9.19575H13V10.0019C13 10.5658 12.6847 11.076 12.1773 11.3334L8.69133 13.1013C8.479 13.2089 8.23989 13.266 8 13.266C7.76022 13.266 7.521 13.2089 7.30867 13.1013L3.82289 11.3334C3.31533 11.076 3 10.5658 3 10.0019V9.19575H4.28533V10.0019C4.28533 10.0872 4.33311 10.1643 4.40989 10.2031L7.35733 11.698V10.217C6.35322 9.9389 5.61433 9.02673 5.61433 7.94676C5.61433 6.6466 6.68456 5.58881 8 5.58881C9.31544 5.58881 10.3857 6.6466 10.3857 7.94676C10.3857 9.02673 9.64678 9.9389 8.64267 10.217V11.6981L11.5903 10.2031Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnkr);
export default __webpack_public_path__ + "static/media/ankr.762a91ca.svg";
export { ForwardRef as ReactComponent };